import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { LayoutMain } from "@unisearch/theme/layout";
import { AuthSignup } from "@unisearch/auth";
import { authService } from "@unisearch/auth";

const Signup = () => {
  const router = useRouter();
  const profileInfo = authService.getProfileData();

  if (profileInfo && profileInfo.userTypeSlug) {
    router.push(`/app/${profileInfo.userTypeSlug}`);

    return false;
  }

  return (
    <LayoutMain
      title="Signup Mentor"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/signup-mentor`}
    >
      <AuthSignup userTypeSlug="mentor" />
    </LayoutMain>
  );
};

export default Signup;
